// explode class strings into an array
export function unpackClasses(classes) {
    return classes.split(" ");
}

// Join multiple css class strings together
export function packClasses(...classes) {
    return classes.filter(Boolean).join(" ");
}

export function replaceClass(classNames, oldClass, newClass) {
    const classes = unpackClasses(classNames);
    if (classes.indexOf(oldClass) === -1) {
        return [...classes, newClass].join(" ");
    }

    return [...classes.filter((c) => c !== oldClass), newClass].join(" ");
}

export function hasClass(classNames, checkClass) {
    if (!classNames || !classNames.length) {
        return false;
    }
    const classes = unpackClasses(classNames);
    return classes.indexOf(checkClass) !== -1;
}

// get random array element
export function arrayRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

// NONCES ARE NOT CRYPTOGRAPHICALLY SECURE.
// You should only use nonces when you simply need a random value
// for refresh or location purposes.
export function nonce(length = 16) {
    const out = [];
    const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
        out.push(chars.charAt(Math.floor(Math.random() * chars.length)));
    }

    return out.join("");
}

export function pathSegment(idx) {
    let parts = window.location.pathname.trim();
    if (parts[0] === "/") {
        parts = parts.substr(1);
    }
    if (parts[parts.length - 1] === "/") {
        parts = parts.substr(-1);
    }
    parts = parts.split("/");
    if (typeof parts[idx] !== "undefined") {
        return parts[idx];
    }

    return null;
}

export function pathQuery(key) {
    let parts = window.location.search;
    if (!parts) {
        return null;
    }
    parts = parts.substr(1);
    parts = parts.split("&");
    for (let i = 0; i < parts.length; i++) {
        const values = parts[i].split("=");
        if (values[0] === key) {
            return values[1];
        }
    }
    return null;
}

export function buildPath(path, params = {}, combine = false) {
    let useParams = params;
    if (combine === true) {
        useParams = Object.assign(
            {},
            Object.fromEntries(new URLSearchParams(window.location.search)),
            params
        );
    }
    return path.concat("?").concat(new URLSearchParams(useParams));
}

export function template(template, data) {
    return template.replace(/\{([^}]+)\}/g, (match, key) => {
        return data[key];
    });
}

export function trimSlashes(str) {
    return str.replace(/^\/|\/$/g, "");
}

export function forceInt(val) {
    if (isNaN(parseInt(val))) {
        return null;
    }
    return parseInt(val);
}
